import { gql } from '@apollo/client';

const cartAddressFragment = gql`
  fragment cartAddress on CartAddress {
    id
    customerAddress {
      id
    }
    firstName
    lastName
    company
    street
    zip
    city
    country
    phone
  }
`;

const customerAddressFragment = gql`
  fragment customerAddress on CustomerAddress {
    id
    firstName
    lastName
    company
    street
    zip
    city
    country
    countryCode
    regionCode
    isDefaultBilling
    isDefaultShipping
    phone
  }
`;

export { cartAddressFragment, customerAddressFragment };
